import { AuditableEntity } from './AuditableEntity';

export abstract class BaseEntity extends AuditableEntity {
    Id: number;
}